/*globals $, ajaxUrl, LINK */

$(document).ready(function () {
    "use strict";

    $("[name=\"toggle-ingredient\"]").on("change", function () {
        var toggleParent = $(this).parents("[data-ingredient-type]");

        getToggleIngredients(toggleParent.data("ingredient-type"));
    });

    $("[data-toggle-ingredient]").on("click", function (e) {
        e.preventDefault();
        var toggleParent = $(this).parents("[data-ingredient-type]"),
            toggleType = $(this).data("toggle-ingredient");
        updateCountIngredients(toggleType, toggleParent);
    });
    
    $("#masterpieceName").on("blur", function () {
        saveMasterpieceName($(this).val());
    });
    
    $("[data-toggle-section]").on("click", function (e) {
        e.preventDefault();
        var pageTabs = $("#subMenu").find("[data-custom-link=\"tab\"]"),
            sectionType = $(e.target).data("toggle-section"),
            sectionLink;

        $.each(pageTabs, function () {
            sectionLink = LINK.getTarget($(this));

            if (sectionLink.indexOf(sectionType) > -1) {
                LINK.tab($(this));
                location.href = sectionLink;
                tabSection(sectionLink);
            }
        });
    });
    
    $("[data-custom-link=\"tab\"]").on("click", function (e) {
        tabSection(LINK.getTarget($(this)));
    });
});

function tabSection(href) {
    "use strict";

    switch (href) {
    case "#my-masterpiece":
        getIngredientList();
        break;
    }
}

function toggleLinks(toggle) {
    "use strict";

    var links   = $("[data-toggle-section], [data-custom-link=\"tab\"]"),
        linkCls = "disabled";

    switch (toggle) {
    case "enable":
        links.removeClass(linkCls);
        break;
    case "disable":
        links.addClass(linkCls);
        break;
    }
}

function runAjax(data, callback) {
    "use strict";

    toggleLinks("disable");

    var ajax = $.ajax({
            type: "post",
            url: ajaxUrl,
            dataType: "json",
            data: data
        }),
        fn = window[callback];

    ajax.done(function (response) {
       toggleLinks("enable");

        if (typeof fn === "function") {
            fn(response);
        } else {
            //console.log(response);
        }
    });
}

function saveIngredients(type, ingredients) {
    "use strict";

    var ingredientData = {
            "action": "update_cyo_ingredients",
            "column": type,
            "ingredients": ingredients.join(";")
        };
    runAjax(ingredientData, "getIngredientList");
}

function removeIngredient(id, type) {
    "use strict";

    var toggleNode,
        toggleParent;

    switch (type) {
    case "ice_cream":
        toggleNode = $("[data-ingredient=\"" + id + "\"]");
        toggleParent = toggleNode.parents("[data-ingredient-type]");
        updateCountIngredients("remove", toggleParent);
        break;
    case "toppings":
        toggleNode = $("[value=\"" + id + "\"]");
        toggleNode.removeAttr("checked");
        getToggleIngredients(type);
        break;
    }
}

function getIngredientType(type) {
    "use strict";
    return type.replace(" ", "_").toLowerCase();
}

function getIngredientList() {
    "use strict";

    var ingredientData = {
            "action": "get_cyo_ingredientlist"
        };
    runAjax(ingredientData, "setIngredientList");
}

function setIngredientList(ingredients) {
    "use strict";

    var ingredientContainer = $("#orderDetailList"),
        ingredientNode;
    ingredientContainer.empty();
    
    $.each(ingredients, function (key, value) {
        if (getIngredientType(value.type) === "cone") {
            return true;
        }
        ingredientNode = $("<p>", {
            "class": "ingredient-list-item",
            "data-ingredient-type": getIngredientType(value.type),
            "html": value.title
        }).on("click", function () {
            removeIngredient(value.id, getIngredientType(value.type));
            $(this).remove();
        });
        ingredientContainer.append(ingredientNode);
    });
    setMasterpieceDisplay(ingredients);
}

function setMasterpieceDisplay(ingredients) {
    "use strict";

    var masterpieceHolder = $("#masterpieceDisplay"),
        flavorNode = $("<div>", { "class": "ice-cream-holder" }),
        toppingNode = $("<div>", { "class": "toppings-holder" }),
        coneNode = $("<div>", { "class": "cone-holder" }),
        ingredientType,
        ingredientTitle;
    masterpieceHolder.empty();

    $.each(ingredients, function (key, value) {
        ingredientType = getIngredientType(value.type);
        ingredientTitle = value.title.replace(/<\/?[^>]+(>|$)/g, "");
        switch (ingredientType) {
        case "ice_cream":
            flavorNode.append("<div class=\"flavor\"><img src=\"" + value.image + "\" alt=\"" + ingredientTitle + "\"></div>");
            break;
        case "toppings":
            toppingNode.append("<div class=\"topping\"><img src=\"" + value.image + "\" alt=\"" + ingredientTitle + "\"></div>");
            break;
        case "cone":
            coneNode.append("<img src=\"" + value.image + "\" alt=\"" + ingredientTitle + "\">");
            break;
        }
        masterpieceHolder
            .append(toppingNode)
            .append(flavorNode)
            .append(coneNode);
    });
}

function saveMasterpieceName(name) {
    "use strict";

    var nameData = {
            "action": "update_cyo_name",
            "name": name
        };
    runAjax(nameData);
}

function getToggleIngredients(ingredient) {
    "use strict";

    var ingredientSection = $("[data-ingredient-type=\"" + ingredient + "\"]"),
        ingredientCount = ingredientSection.find("[name=\"toggle-ingredient\"]"),
        ingredientId = 0,
        ingredients = [];

    $.each(ingredientCount, function () {
        ingredientId = parseInt($(this).val(), 10);

        if ($(this).is(":checked")) {
            ingredients.push(ingredientId);
        }
    });
    saveIngredients(ingredient, ingredients);
}

function getCountIngredients(ingredient) {
    "use strict";

    var ingredientSection = $("[data-ingredient-type=\"" + ingredient + "\"]"),
        ingredientCount = ingredientSection.find("[data-ingredient-count]"),
        ingredientId = 0,
        numOfIngredients = 0,
        ingredients = [],
        i;

    $.each(ingredientCount, function () {
        ingredientId = $(this).data("ingredient");
        numOfIngredients = parseInt($(this).text(), 10);

        for (i = 0; i < numOfIngredients; i += 1) {
            ingredients.push(ingredientId);
        }
    });
    saveIngredients(ingredient, ingredients);
}

function updateCountIngredients(toggleType, toggleParent) {
    "use strict";

    var ingredientCountHolder = toggleParent.find("[data-ingredient-count]"),
        ingredientCount = parseInt(ingredientCountHolder.text(), 10);

    switch (toggleType) {
    case "add":
        ingredientCount += 1;
        break;
    case "remove":
        if (ingredientCount > 0) {
            ingredientCount -= 1;
        }
        break;
    }
    ingredientCountHolder.text(ingredientCount);
    getCountIngredients(toggleParent.data("ingredient-type"));
}